type TrackNavigationPayload = {
	name?: string | null
	bank?: string
	bannerCampaignID?: string
	userId?: string
	pageName: string
	section?: string
	subsection?: string
	isFinalStep?: boolean
}

export const trackNavigation = ({
	name = '',
	bank = '',
	bannerCampaignID = '',
	userId = '',
	pageName,
	section = '',
	subsection = '',
	isFinalStep = false,

}: TrackNavigationPayload) => {
	const satellite = window._satellite

	if (!satellite?.setVar || !satellite?.track) return

	satellite.setVar('iccrea_channel', 'simulatore prestito')
	satellite.setVar('iccrea_name', name) //presente solo nello step richiesta finale (5)
	satellite.setVar('iccrea_url', window.location.href)

	satellite.setVar('iccrea_bank', bank)
	//satellite.setVar('iccrea_bannerCampaignID', bannerCampaignID)
	satellite.setVar('iccrea_userId', userId)

	satellite.setVar('iccrea_pageName', pageName)
	satellite.setVar('iccrea_section', section)
	satellite.setVar('iccrea_subsection', subsection)
	satellite.setVar('iccrea_language', 'it')
	satellite.setVar('iccrea_urlNoParameter','crediper')


	if (isFinalStep) {
		satellite.track('clickCTAInvioRichiestaSimulatoreCRP')
	} else {
		satellite.track('navigazione')
	}
}